import { url } from '@api-config';

export const urls = {
  getDataSource: url.dataSource,
  getDataSourceType: url.dataSourceType,
  getDataSourceForEdit: (id: number | string | undefined) => `${url.dataSource}/${id}`,

  // tables
  getDataSourceTables: (sourceId: number, pageLimit: number, pageNumber: number, term: string) =>
    `${url.dataSet}/dataSource/${sourceId}/tables?pageLimit=${pageLimit}&pageNumber=${pageNumber}&searchPattern=${term}`,

  // table columns
  getDataSourceTableColumns: (
    sourceId: number,
    tableName: string,
    pageLimit: number | null,
    pageNumber: number,
    term: string
  ) =>
    `${url.dataSet}/dataSource/${sourceId}/tableColumns?tableName=${tableName}&pageLimit=${pageLimit}&pageNumber=${pageNumber}&searchPattern=${term}`,
  putDataSourceTableColumnUri: (
    dataSourceId: string | undefined,
    tableName: string | undefined,
    columnName: string,
    selected: boolean
  ) =>
    `${
      url.dataSet
    }/dataSource/${dataSourceId}?tableName=${tableName}&columnName=${encodeURIComponent(
      columnName
    )}&selected=${selected}`,

  getDataPreviewUri: (dataSourceId: string | undefined, tableName: string, filterText: string) => {
    const urlBase = `${url.dataSet}/dataSource/${dataSourceId}/data?tableName=${encodeURIComponent(
      tableName
    )}`;

    const urlWithFilterText =
      filterText?.length > 0 ? `${urlBase}&filterText=${encodeURIComponent(filterText)}` : urlBase;

    return urlWithFilterText;
  },

  // timeprops
  getTimeProps: (dataSourceId: string | undefined, tableName: string | undefined) =>
    `${url.dataSet}/dataSource/${dataSourceId}/timeprops?tableName=${encodeURIComponent(
      tableName || ''
    )}`,
  putTimeProps: (dataSourceId: string | undefined, tableName: string | undefined) =>
    `${url.dataSet}/dataSource/${dataSourceId}/timeprops?tableName=${encodeURIComponent(
      tableName || ''
    )}`,
  deleteTimeProps: (dataSourceId: string | undefined, tableName: string | undefined) =>
    `${url.dataSet}/dataSource/${dataSourceId}/timeprops?tableName=${encodeURIComponent(
      tableName || ''
    )}`,
};

const FALLBACK_COLUMN_COUNT_PER_PAGE = 10;
export const calculatePaginationCount = (
  totalCount: number,
  searchCount: number,
  searchStr: string,
  colCountPerPage: number | undefined
): number => {
  const total = searchStr.length > 0 ? searchCount : totalCount;
  const effectiveColCountPerPage = colCountPerPage || FALLBACK_COLUMN_COUNT_PER_PAGE;
  if (effectiveColCountPerPage <= 0) {
    return 1; // default for invalid perPage
  }
  return Math.ceil(total / effectiveColCountPerPage);
};

export const DATASOURCE_ERROR_TEXT = {
  loadingDataSources: {
    unknown: 'There was an error fetching the data sources.',
  },
  loadingTables: {
    unknown: 'There was an error fetching the tables for this Data Source.',
  },
  loadingTableColumns: {
    unknown: 'There was an error fetching the columns for this Data Set.',
  },
};
